// api/upcomingEvents.js
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://stage.getrevibe.app/api";

export const fetchUpcomingEventsAPI = async ({
  sortOrder = "desc",
  page = 1,
  limit = 10,
  search = "",
} = {}) => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("No authentication token found");
  }

  const params = new URLSearchParams({ sortOrder, page, limit, search });

  const response = await fetch(`${API_BASE_URL}/mux?${params}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error("Unauthorized. Please login again.");
    }
    throw new Error("Failed to fetch upcoming events");
  }

  const data = await response.json();
  return data.streams || [];
};